import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "@auth0/auth0-angular";
import { AdminPermissionGuard } from "./guards/adminPermission/admin-permission.guard";
import { FeatureFlagsGuard } from "./guards/featureFlag/feature-flags.guard";
import { UserLoaderGuard } from "./guards/userLoader/user-loader.guard";
import { ApiComponent } from "./views/api/api/api.component";
import { ChangelogComponent } from "./views/changelog/changelog.component";
import { HygieneComponent } from "./views/hygiene/hygiene.component";
import { IssuesComponent } from "./views/issues/issues.component";
import { IntegrationsComponent } from "./views/integrations/integrations.component";
import { InventoryComponent } from "./views/inventory/inventory.component";
import { LayoutComponent } from "./views/layout/layout.component";
import { LoginComponent } from "./views/login/login.component";
import { MainDashboardComponent } from "./views/main-dashboard/main-dashboard.component";
import { AccountManagementComponent } from "./views/management/account-management/account-management.component";
import { PlaybookComponent } from "./views/playbook/playbook.component";
import { PlaybooksComponent } from "./views/playbooks/playbooks.component";
import { PoliciesComponent } from "./views/policies/policies.component";
import { PolicyComponent } from "./views/policy/policy.component";
import { SupportComponent } from "./views/support/support.component";
import { ViolationsComponent } from "./views/violations/violations.component";
import { VisibilityDashboardComponent } from "./views/visibility-dashboard/visibility-dashboard.component";
import { ErrorLoginComponent } from "./views/error-login/error-login.component";
import { EnterpriseAiDetectionTabsManagementComponent } from "./views/enterprise-ai/enterprise-ai-detection-tabs-management/enterprise-ai-detection-tabs-management.component";
import { EnterpriseAiDashboardComponent } from "./views/enterprise-ai/enterprise-ai-dashboard/enterprise-ai-dashboard.component";
/**
 * The routing of the app.
 * Each new route needs to be added here.
 * This module is exported as AppRoutingModule and inside the app.module in imported and added to the imports
 */
const routes: Routes = [
    { path: "login", component: LoginComponent, pathMatch: "full" },
    { path: "error-login", component: ErrorLoginComponent, pathMatch: "full" },
    {
        path: "app/support",
        component: SupportComponent,
        canActivate: [AuthGuard, UserLoaderGuard],
    },
    {
        path: "app",
        component: LayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: "",
                component: MainDashboardComponent,
                canActivate: [UserLoaderGuard],
                pathMatch: "full",
            },
            {
                path: "visibility",
                component: VisibilityDashboardComponent,
                canActivate: [FeatureFlagsGuard],
            },
            {
                path: "ai",
                component: EnterpriseAiDashboardComponent,
                canActivate: [FeatureFlagsGuard],
            },
            {
                path: "ai-detection",
                component: EnterpriseAiDetectionTabsManagementComponent,
                canActivate: [FeatureFlagsGuard],
            },
            {
                path: "integrations",
                component: IntegrationsComponent,
                canActivate: [UserLoaderGuard],
            },
            {
                path: "violations",
                component: ViolationsComponent,
                canActivate: [UserLoaderGuard],
            },
            {
                path: "hygiene",
                component: HygieneComponent,
                canActivate: [UserLoaderGuard],
            },
            {
                path: "issues",
                component: IssuesComponent,
                canActivate: [FeatureFlagsGuard],
            },
            {
                path: "policies",
                component: PoliciesComponent,
                canActivate: [FeatureFlagsGuard],
            },
            {
                path: "policies/:id",
                component: PolicyComponent,
                canActivate: [FeatureFlagsGuard],
            },
            { path: "inventory", component: InventoryComponent },
            {
                path: "playbooks",
                component: PlaybooksComponent,
                canActivate: [FeatureFlagsGuard],
            },
            {
                path: "playbooks/new",
                component: PlaybookComponent,
                canActivate: [FeatureFlagsGuard],
            },
            {
                path: "playbooks/:id",
                component: PlaybookComponent,
                canActivate: [FeatureFlagsGuard],
            },
            {
                path: "playbooks/:id/copy",
                component: PlaybookComponent,
                canActivate: [FeatureFlagsGuard],
            },
            {
                path: "playbooks/new/templates/:templateId",
                component: PlaybookComponent,
                canActivate: [FeatureFlagsGuard],
            },
            {
                path: "management",
                component: AccountManagementComponent,
                canActivate: [AdminPermissionGuard],
            },
            // Below is needed for OAuth Authorization code flow
            {
                path: "oauth-authorization-code-redirect",
                component: MainDashboardComponent,
            },
        ],
    },
    {
        path: "redoc",
        component: ApiComponent,
        canActivate: [AuthGuard, FeatureFlagsGuard],
    },
    {
        path: "changelog",
        component: ChangelogComponent,
        canActivate: [AuthGuard, FeatureFlagsGuard],
    },
    { path: "**", redirectTo: "app" },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
